// extracted by mini-css-extract-plugin
var _1 = "_tKYGz";
var _2 = "__KdEC";
export { _1 as "drawer", _2 as "drawerContent" }
